import { render, staticRenderFns } from "./Aseguradoras.vue?vue&type=template&id=1076504a&lang=html&"
import script from "./Aseguradoras.vue?vue&type=script&lang=js&"
export * from "./Aseguradoras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports